export enum MenuItemDisplayStyle {
  NameAndDescription = 0,
  NameAndImage = 1,
  Wide = 2,
  NameDescriptionAndImage = 3,
}
